import React, { useState, useEffect } from 'react';
import { RayForm } from '../common';
import { Translate as t } from '../../config/Translate';

const ProductSimpleInfo = ({ product }) => {
	const isAdmin = location.pathname.toLowerCase().startsWith('/admin/');
	const [contols, setControls] = useState([]);

	const showKey = [
		{
			label: t('product.field.sn'), value: "sn",
			link: isAdmin ? "/Admin/AdminProductInfo/" : "/Product/"
		},
		{ label: t('product.field.model'), value: "model" },
		{ label: t('common.label.option'), value: "option" },
		{ label: t('common.label.status'), value: "status" },
		{ label: t('installation.field.installedDate'), value: "installedDate" },
		{ label: t('product.label.lastConnect'), value: "lastConnectedDate" }
	]

	useEffect(() => {
		const objs = [];
		showKey.map(x => {
			if (product[x.value]) {
				const obj = {
					title: '', items: [{
						type: 'input',
						name: x.value,
						label: x.label,
						viewLinkPath: x.link,
						val: product[x.value],
						valtype: x.value.indexOf("Date") > -1 ? "date" : "",
						size: 12
					}]
				};
				objs.push(obj);
			}
		});
		objs[0].title = "";
		setControls(objs);
	}, []);

	return <RayForm controls={contols} />;
};

export default ProductSimpleInfo;
